
















































import { Component, Vue, Prop } from 'vue-property-decorator'
import CustomForm from '@/components/custom-form/index.vue'
import AbpBase from '@/lib/abpbase'
import CustomTableApi from '@/api/customTable/index'
@Component({
  components: {
    CustomForm,
  },
})
export default class CustomTable extends AbpBase {
  @Prop({
    type: Boolean,
    default: true,
  })
  showBtn!: boolean
  @Prop({
    type: Boolean,
    default: true,
  })
  isShowPage!: boolean
  @Prop({
    type: Boolean,
    default: false,
  })
  isChecked!: boolean
  @Prop({
    type: Boolean,
    default: true,
  })
  isMultiple!: boolean
  @Prop({
    type: String,
    default: '选择店铺',
  })
  btnText!: string
  @Prop({
    type: Array,
    default: () => [],
  })
  columns!: []
  @Prop({
    type: Array,
    default: () => [],
  })
  filters!: []
  @Prop({
    type: String,
    default: '',
  })
  customTableTitle!: string
  @Prop({
    type: String,
    default: '',
  })
  tableApi!: string
  @Prop({
    type: Array,
    default: () => []
  })
  selectedItems!: []
  loading: boolean = false
  isCheckAll: boolean = false
  data: any[] = []
  selectedIds: any = new Set()
  openCustomTabel: boolean = false
  page: any = {
    maxResultCount: 10,
    currentPage: 1,
    totalCount: 0,
  }
  rightColumns: any[] = [
    {
      title: '名称',
      key: 'displayName',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
      type: 'action',
      width: 100
    },
  ]
  rightData: any[] = []
  handleClickSelect() {
    this.openCustomTabel = true
    this.submitFn()
  }
  onSubmit(form) {
    this.getDataList(form)
  }
  handleQuery() {
    this.page.currentPage = 1
    this.submitFn()
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    console.log(form)
    form.submit()
  }
  deleteItem(row, index) {
    console.log(row, index);
    this.rightData.splice(index, 1);
    let tempIndex = this.data.findIndex(item => item.id == row.id);
    (this.$refs.selection as any).toggleSelect(tempIndex)
  }
  closeModal() {
    let form: any = this.$refs.lineForm
    form.reset();
    this.openCustomTabel = false
    this.rightData = []
  }
  getDataList(form?) {
    let { page } = this
    this.loading = true
    this.isCheckAll = false
    let copyForm: any = {}
    console.log('test', form)
    if (form.dateTimeRange) {
      copyForm.BeginTime = this.dateString(form['dateTimeRange'][0])
      copyForm.EndTime = this.dateString(form['dateTimeRange'][1])
      copyForm = { ...copyForm, ...form }
      delete copyForm.dateTimeRange
    } else {
      copyForm = { ...form }
    }
    CustomTableApi.getDataList(this.tableApi, page.currentPage, page.maxResultCount, copyForm)
      .then((res) => {
        this.loading = false
        let result = []
        if(this.rightData.length) {
          res.data.items.forEach((element) => {
            element['_checked'] = this.rightData.findIndex((x) => x.id == element.id) > -1;
            result.push(element)
          })
        }else {
          res.data.items.forEach((element) => {
            if (this.isChecked) {
              element['_checked'] = this.selectedItems.findIndex((x) => x == element.id) > -1;
              if(element['_checked']) {
                let obj = this.rightData.find(item => item.id == element.id)
                if(!obj) {
                  this.rightData.push(element)
                }
              }
            } else {
              element['_disabled'] = this.selectedItems.findIndex((x) => x == element.id) > -1
            }
            result.push(element)
          })
        }
        
        this.data = result
        page.totalCount = res.data.totalCount
      })
      .catch((err) => {
        this.loading = false
      })
  }
  pageSizeChange(e) {
    this.page.maxResultCount = e
    this.page.currentPage = 1
    this.submitFn()
  }
  changePage(e) {
    this.page.currentPage = e
    this.submitFn()
  }
  sure() {
    let selection = (this.$refs.selection as any).getSelection()
    if (this.rightData.length) {
      // console.log(selection);
      let form: any = this.$refs.lineForm
      form.reset();
      this.openCustomTabel = false
      this.$emit('on-select-row', this.rightData)
      this.rightData = []
    } else {
      this.$Notice.warning({
        title: '请先选择数据',
      })
    }
  }
  handleTableAllCancel(selection) {
    this.isCheckAll = false
    let data = (this.$refs.selection as any).data
    data.forEach((item) => {
      if (this.selectedIds.has(item.id)) {
        this.selectedIds.delete(item.id)
      }
    });
    this.rightData = []
  }

  handleTableAll(selection) {
    this.isCheckAll = true
    selection.forEach((item) => {
      this.selectedIds.add(item.id)
    });
    this.rightData = selection
  }

  handleSelectChange(selection) {
    // console.log('选项发生变化', selection);
    this.isCheckAll = selection.length === this.data.length
  }

  handleSelect(slection, row) {
    this.rightData.push(row)
    this.selectedIds.add(row.id)
  }
  handleCancel(slection, row) {
    let index = this.rightData.findIndex(item => item.id == row.id)
    if(index > -1) {
      this.rightData.splice(index, 1)
    }
    this.selectedIds.delete(row.id)
  }
  handleClickRow(row) {
    if (!this.isMultiple) {
      this.$emit('clickRowItem', row)
      this.openCustomTabel = false
    }
  }
}
